import React from 'react';
import { View } from '../types';
import { Shield, Target, BookOpen } from 'lucide-react';

interface HomeProps {
  start: () => void;
  progress: number;
}

export const Home: React.FC<HomeProps> = ({ start, progress }) => {
  return (
    <div className="max-w-4xl mx-auto p-6 md:p-12">
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-6xl font-bold mb-6 text-cyber-dark">
          Understand the <span className="text-cyber-accent">Threat</span>. <br/>
          Master the <span className="text-cyber-success">Defence</span>.
        </h1>
        <p className="text-xl text-slate-600 mb-8 max-w-2xl mx-auto">
          A comprehensive, beginner-friendly guide to modern malware. Learn how attacks work, who they target, and how to protect yourself and your organization.
        </p>
        
        <button 
          onClick={start}
          className="bg-cyber-accent hover:bg-blue-600 text-white text-xl font-bold py-4 px-10 rounded-full shadow-lg transform hover:scale-105 transition-all"
        >
          {progress > 0 ? 'Continue Learning' : 'Start Module'}
        </button>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mt-16">
        <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-cyber-danger">
          <Target className="w-12 h-12 text-cyber-danger mb-4" />
          <h3 className="text-xl font-bold mb-2">Identify Threats</h3>
          <p className="text-slate-600">Learn to distinguish between viruses, worms, ransomware, and more.</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-cyber-warning">
          <BookOpen className="w-12 h-12 text-cyber-warning mb-4" />
          <h3 className="text-xl font-bold mb-2">Understand Impact</h3>
          <p className="text-slate-600">See how malware affects the Confidentiality, Integrity, and Availability of data.</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-cyber-success">
          <Shield className="w-12 h-12 text-cyber-success mb-4" />
          <h3 className="text-xl font-bold mb-2">Build Defence</h3>
          <p className="text-slate-600">Master the playbook: Patching, MFA, Backups, and Incident Response.</p>
        </div>
      </div>
    </div>
  );
};
